exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputfile[data-v-3382cca6]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader[data-v-3382cca6]{margin:0 0 0 1%;padding:0;cursor:pointer}.hand[data-v-3382cca6]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3382cca6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ProductDTO.vue
// module id = 422
// module chunks = 0